import { StyleSheet, css } from 'aphrodite';
import { PropTypes } from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Theme } from '../../config/theme';
import { mapDispatchToProps, mapStateToProps } from '../../utils';

import { ROUTES } from '../../config/routes';

import { updateAppState } from '../../actions/applicationState';
import { search } from '../../actions/search';

import ContentContainer from '../../components/ContentContainer';
import DogCard from '../../components/DogCard';
import FindADog from '../../components/FindADog';
import GlobalMessage from '../../components/GlobalMessage';
import ShowMoreTrigger from '../../components/ShowMoreTrigger';
import SimpleSelect from '../../components/SimpleSelect';

class Find extends Component {
  constructor(props) {
    super(props);

    this.state = {
      sort: 'proximity',
      count: 0,
      page: 0,
      loaded: false,
      results: [],
      interests: this.props.search.interests,
      needs: this.props.search.needs,
      district: this.props.search.district,
      suburb: this.props.search.suburb,
      breeds:
        this.props.search.breeds && this.props.search.breeds.length
          ? this.props.search.breeds.pop()
          : null,
      searchQuery: '',
      district_title: null,
      loaded_district_title: null,
      filterVisibleMob: false,
      nearestMe: true,
      maxDegrees: 5,
      isInitialSearch: true,
    };

    this.handleSearch = this.doSearch.bind(this);
    this.loadNextPage = this.doLoadMore.bind(this);
    this.handleInterests = this.toggleInterest.bind(this);
    this.clearInterests = this.clearInterests.bind(this);
    this.clearNeeds = this.clearNeeds.bind(this);
    this.handleNeeds = this.toggleNeeds.bind(this);
    this.handleDistrict = this.setDistrict.bind(this);
    this.handleSuburb = this.setSuburb.bind(this);
    this.handleBreeds = this.setBreeds.bind(this);
    this.setValue = this.updateField.bind(this);
    this.toggleNearestMe = this.toggleNearestMe.bind(this);
    // this.toggleMobFilter = this.toggleMobFilter.bind(this);

    this.setSort = this.setSort.bind(this);

    // Debounce timer for search query
    this.searchDebounceTimer = null;

    this.sortOptions = [
      {
        label: 'Latest',
        value: 'latest',
      },
      {
        label: 'Name',
        value: 'name',
      },
      {
        label: 'Dog Size (smallest to largest)',
        value: 'dogsize-asc',
      },
      {
        label: 'Dog Size (largest to smallest)',
        value: 'dogsize-desc',
      },
    ];

    // Add proximity sort option when nearestMe is active
    this.sortOptionsWithProximity = [
      ...this.sortOptions,
      {
        label: 'Distance (nearest first)',
        value: 'proximity',
      },
    ];
  }

  componentWillMount() {
    // Redirect the user to verify if they do not have a verifications sent
    if (this.props.user.verified === false) {
      this.props.history.push('/join/verify');
    } else if (!this.props.user.completed_membership) {
      // Redirect the user to Membership if they do not have an active subscription
      this.props.history.push('/join/profile');
    }
  }

  componentDidMount() {
    if (this.isSubscriptionActive()) {
      this.doSearch(false, true);
    }
  }

  componentWillUnmount() {
    // Clear debounce timer on unmount
    if (this.searchDebounceTimer) {
      clearTimeout(this.searchDebounceTimer);
    }
  }

  getResults() {
    return this.state.results.length ? (
      <div className={css(styles.cards)}>
        {this.state.results.length
          ? this.state.results.map(dog => {
              const proximityText =
                this.state.nearestMe && dog.proximity_degree !== undefined
                  ? dog.proximity_degree === 0
                    ? 'In your suburb'
                    : dog.proximity_degree === 1
                    ? '1 suburb away'
                    : `${dog.proximity_degree} suburbs away`
                  : null;

              return (
                <DogCard
                  key={dog.id || dog.dog_id}
                  id={dog.id || dog.dog_id}
                  image={dog.image_url}
                  name={dog.name}
                  breed={dog.breed}
                  summary={dog.bio}
                  interests={dog.interests}
                  needs={dog.needs}
                  suburb={dog.suburb}
                  proximityText={proximityText}
                />
              );
            })
          : false}
      </div>
    ) : (
      <h3 className={css(styles.no_results)}>No dogs matched those filters!</h3>
    );
  }

  setDistrict(name, district) {
    // If nearestMe is active, don't allow district selection
    if (this.state.nearestMe) {
      return;
    }

    this.setState(
      {
        district: district ? district.value : null,
        district_title: district ? district.label : null,
        // Reset suburb when district changes
        suburb: null,
        suburb_title: null,
      },
      () => {
        // Automatically trigger search after state update
        this.doSearch();
      },
    );
  }

  setSuburb(name, suburb) {
    // If nearestMe is active, don't allow suburb selection
    if (this.state.nearestMe) {
      return;
    }

    this.setState(
      {
        suburb: suburb ? suburb.value : null,
        suburb_title: suburb ? suburb.label : null,
      },
      () => {
        // Automatically trigger search after state update
        this.doSearch();
      },
    );
  }

  setBreeds(name, breed) {
    this.setState(
      {
        breeds: breed ? breed.value : null,
      },
      () => {
        // Automatically trigger search after state update
        this.doSearch();
      },
    );
  }

  setSort(key, value) {
    this.setState({
      sort: value,
    });

    this.performSearch(
      this.state.searchQuery,
      this.state.interests,
      this.state.district,
      this.state.suburb,
      this.state.breeds,
      this.state.needs,
      this.state.page,
      value,
    );
  }

  updateField(key, value) {
    this.setState(
      {
        [key]: value,
      },
      () => {
        // If updating search query, debounce the search
        if (key === 'searchQuery') {
          // Clear existing timer
          if (this.searchDebounceTimer) {
            clearTimeout(this.searchDebounceTimer);
          }

          // Set new timer to trigger search after 500ms of no typing
          this.searchDebounceTimer = setTimeout(() => {
            this.doSearch();
          }, 500);
        }
      },
    );
  }

  /**
   * Check if the user has an active subscription.
   * @NOTE: This should be split into a utility function
   * but the way that the store has been implemented would require refactoring.
   */
  isSubscriptionActive() {
    const { user } = this.props;

    if (!user) {
      return false;
    }

    const { active_subscription: ACTIVE } = user;

    return ACTIVE;
  }

  doLoadMore() {
    this.performSearch(
      this.state.searchQuery,
      this.state.interests,
      this.state.district,
      this.state.suburb,
      this.state.breeds,
      this.state.needs,
      this.state.page + 1,
      this.state.sort,
    );
  }

  performSearch(
    query,
    interests,
    district,
    suburb,
    breeds,
    needs,
    page,
    sort = null,
    showLoading = true,
  ) {
    // When nearestMe is active, don't send district/suburb
    const districtQuery = this.state.nearestMe ? null : district;
    const suburbQuery = this.state.nearestMe ? null : suburb;
    const breedsQuery = typeof breeds === 'number' ? [breeds] : null;
    const interestsQuery = interests && interests.length ? interests : null;
    const needsQuery = needs && needs.length ? needs : null;

    this.props
      .dispatch(
        updateAppState({
          loading: showLoading,
          loading_text: 'Fetching...',
        }),
      )
      .then(() => {
        this.props
          .dispatch(
            search(
              query,
              interestsQuery,
              districtQuery,
              suburbQuery,
              breedsQuery,
              needsQuery,
              page,
              'search',
              sort,
              this.props.user.access_token,
              this.state.nearestMe,
              this.state.maxDegrees,
            ),
          )
          .then(results => {
            // Check if this is the initial search and no results were found with nearestMe enabled
            const shouldRetryWithoutNearestMe =
              this.state.isInitialSearch && this.state.nearestMe && results.dogs.length === 0;

            if (shouldRetryWithoutNearestMe) {
              // Mark that we've completed the initial search attempt
              this.setState({ isInitialSearch: false, nearestMe: false }, () => {
                // Retry the search without nearestMe
                this.performSearch(
                  query,
                  interests,
                  district,
                  suburb,
                  breeds,
                  needs,
                  page,
                  'latest', // Change sort to 'latest' when nearestMe is disabled
                  false, // Don't show loading again for the retry
                );
              });
            } else {
              setTimeout(() => {
                this.setState({
                  loaded: true,
                  results: page === 1 ? results.dogs : [].concat(this.state.results, results.dogs),
                  count: results.count,
                  page: results.page,
                  loaded_district_title: this.state.district_title,
                  filterVisibleMob: false,
                  isInitialSearch: false, // Mark initial search as complete
                });

                this.props.dispatch(
                  updateAppState({
                    loading: false,
                    loading_text: false,
                  }),
                );
              }, 1500);
            }
          });
      });
  }

  doSearch(showLoading = true, isInitial = false) {
    document.body.classList.remove('scroll-locked');

    // If this is a manual search, ensure the flag is set to false
    if (!isInitial && this.state.isInitialSearch) {
      this.setState({ isInitialSearch: false });
    }

    this.performSearch(
      this.state.searchQuery,
      this.state.interests,
      this.state.district,
      this.state.suburb,
      this.state.breeds,
      this.state.needs,
      1,
      this.state.sort,
      showLoading,
    );
  }

  // toggleMobFilter() {
  //   if (this.state.filterVisibleMob) {
  //     document.body.classList.remove('scroll-locked');
  //   } else {
  //     document.body.classList.add('scroll-locked');
  //   }
  //
  //   this.setState({
  //     filterVisibleMob: !this.state.filterVisibleMob,
  //   });
  // }

  toggleInterest(selected, interestID) {
    const newInterests = selected
      ? [].concat(this.state.interests, [interestID])
      : this.state.interests.filter(interest => interest !== interestID);

    this.setState(
      {
        interests: newInterests,
      },
      () => {
        // Automatically trigger search after state update
        this.doSearch();
      },
    );
  }

  clearInterests() {
    this.setState(
      {
        interests: [],
      },
      () => {
        // Automatically trigger search after clearing
        this.doSearch();
      },
    );
  }

  toggleNeeds(selected, needID) {
    const newNeeds = selected
      ? [].concat(this.state.needs, [needID])
      : this.state.needs.filter(need => need !== needID);

    this.setState(
      {
        needs: newNeeds,
      },
      () => {
        // Automatically trigger search after state update
        this.doSearch();
      },
    );
  }

  clearNeeds() {
    this.setState(
      {
        needs: [],
      },
      () => {
        // Automatically trigger search after clearing
        this.doSearch();
      },
    );
  }

  toggleNearestMe() {
    const newNearestMe = !this.state.nearestMe;

    this.setState(
      {
        nearestMe: newNearestMe,
        // Clear district/suburb when enabling nearestMe
        district: newNearestMe ? null : this.state.district,
        suburb: newNearestMe ? null : this.state.suburb,
        // If enabling nearestMe and current sort is not supported, default to proximity
        sort: newNearestMe && this.state.sort === 'latest' ? 'proximity' : this.state.sort,
        // Mark that this is a manual action, not the initial search
        isInitialSearch: false,
      },
      () => {
        // Trigger search after state update
        this.doSearch();
      },
    );
  }

  /**
   * Render a message if the subscription has expired.
   * @return {*}
   */
  renderSubscriptionMessage() {
    if (this.isSubscriptionActive()) {
      return null;
    }

    return (
      <p className={css(styles.reactivate_subscription)}>
        To find a dog, please re-activate your subscription. You can do so by navigating to your{' '}
        <Link to={ROUTES.SETTINGS.MEMBERSHIP}>My Membership</Link> tab.
      </p>
    );
  }

  /**
   * Render the filter form
   * @return {*}
   */
  renderFilterForm() {
    if (!this.isSubscriptionActive()) {
      return null;
    }

    return (
      <div>
        {this.props.appdata.globalMessage.enabled ? (
          <div className={css(styles.globalMessage)}>
            <GlobalMessage
              title={this.props.appdata.globalMessage.title}
              message={this.props.appdata.globalMessage.message}
            />
          </div>
        ) : (
          false
        )}
        <div className={css(styles.filters)}>
          <FindADog
            {...this.props}
            interests={this.state.interests}
            breeds={this.state.breeds}
            district={this.state.district}
            suburb={this.state.suburb}
            needs={this.state.needs}
            nearestMe={this.state.nearestMe}
            handleSearch={this.handleSearch}
            handleInterests={this.handleInterests}
            clearInterests={this.clearInterests}
            handleNeeds={this.handleNeeds}
            handleSearchQuery={this.setValue}
            searchQuery={this.state.searchQuery}
            clearNeeds={this.clearNeeds}
            handleBreeds={this.handleBreeds}
            handleDistrict={this.handleDistrict}
            handleSuburb={this.handleSuburb}
            mobFilterVisible={this.state.filterVisibleMob}
          />
        </div>
        {this.state.loaded ? (
          <div className={css(styles.actions)}>
            <div className={css(styles.nearest_me_container)}>
              <label className={css(styles.nearest_me_label)} htmlFor="nearest-me-checkbox">
                <input
                  type="checkbox"
                  id="nearest-me-checkbox"
                  checked={this.state.nearestMe}
                  onChange={this.toggleNearestMe}
                  className={css(styles.nearest_me_checkbox)}
                />
                <span className={css(styles.nearest_me_text)}>Dogs nearest me</span>
              </label>
            </div>
            {this.state.results.length ? (
              <div className={css(styles.sort)}>
                Sort by
                <SimpleSelect
                  id="Sort"
                  name="Sort"
                  label="Sort"
                  hideLabel
                  fullWidth
                  value={this.state.sort}
                  handler={this.setSort}
                  options={this.state.nearestMe ? this.sortOptionsWithProximity : this.sortOptions}
                  styles={styles.sort_select}
                />
              </div>
            ) : null}
          </div>
        ) : null}
        {this.state.loaded ? this.getResults() : false}
      </div>
    );
  }

  render() {
    return (
      <div className={css(styles.container)}>
        <ContentContainer>
          <h1 className={css(styles.heading)}>Find a dog</h1>
          {this.renderSubscriptionMessage()}
          {this.renderFilterForm()}
        </ContentContainer>
        <div className={css(styles.more)}>
          {this.state.results.length && this.state.results.length < this.state.count ? (
            <ShowMoreTrigger handler={this.loadNextPage} />
          ) : (
            false
          )}
        </div>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    padding: '100px 0 0',
    minHeight: '80vh',

    [Theme.mobile_query]: {
      padding: '80px 0 0',
    },
  },
  heading: {
    marginBottom: 45,
    textAlign: 'center',
    fontSize: 45,
    fontFamily: Theme.font_family_heading,
    fontWeight: Theme.font_weight_heading,

    [Theme.mobile_query]: {
      fontSize: 28,
    },
  },
  globalMessage: {
    marginBottom: 25,
  },
  filters: {
    marginBottom: 15,
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 30,
    marginTop: 30,
    paddingLeft: 15,
    paddingRight: 15,

    [Theme.mobile_query]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  mob_find: {
    display: 'block',
    width: '100vw',
    height: 50,
    margin: '0 -15px 30px',
    textTransform: 'uppercase',
    fontSize: 15,
    fontWeight: 900,
    lineHeight: 1.73,
    letterSpacing: 2,
    textAlign: 'center',
    color: Theme.primary,
    border: 0,
    borderTop: '1px solid #cecece',
    borderBottom: '1px solid #cecece',
    backgroundColor: Theme.white,
    cursor: 'pointer',
    outline: 'none',
    transition: 'background-color 300ms',
  },
  location: {
    fontWeight: 'bold',
    fontSize: 15,
    fontFamily: Theme.font_family_primary,
  },
  sort: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 14,
    fontFamily: Theme.font_family_primary,
    fontWeight: Theme.font_weight_primary,
    color: '#828282',
    marginLeft: 'auto',

    [Theme.mobile_query]: {
      marginLeft: 0,
      marginTop: 15,
    },
  },
  sort_select: {
    padding: 0,
    marginBottom: 0,
    marginLeft: 14,
    width: 200,
  },
  cards: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    margin: '0 -15px',

    [Theme.mobile_query]: {
      padding: '0 20px',
    },
  },
  more: {
    position: 'relative',
    height: 120,
    marginTop: 85,
    marginBottom: 85,
    [Theme.mobile_query]: {
      marginTop: 40,
      marginBottom: 0,
    },
  },
  no_results: {
    marginTop: 55,
    textAlign: 'center',
    fontSize: 28,
    marginBottom: 50,
    fontFamily: Theme.font_family_heading,
    fontWeight: Theme.font_weight_heading,
  },
  reactivate_subscription: {
    textAlign: 'center',
    padding: 30,
    marginBottom: 30,
  },
  nearest_me_container: {
    display: 'flex',
    alignItems: 'center',
  },
  nearest_me_label: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    fontSize: 16,
    fontFamily: Theme.font_family_primary,
    fontWeight: Theme.font_weight_secondary,
    color: Theme.black,
  },
  nearest_me_checkbox: {
    width: 20,
    height: 20,
    marginRight: 10,
    cursor: 'pointer',
  },
  nearest_me_text: {
    userSelect: 'none',
  },
});

Find.propTypes = {
  dispatch: PropTypes.func.isRequired,
  user: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  search: PropTypes.array,
  appdata: PropTypes.object,
};

Find.defaultProps = {
  search: [],
  appdata: {},
};

export default connect(mapStateToProps, mapDispatchToProps)(Find);



// WEBPACK FOOTER //
// ./src/views/Find/index.js